import React from "react"

interface CampaignStatsHeaderProps {
  selectedDays: number
  startDate: string
  endDate: string
  loading: boolean
  statsData: { data: unknown[] } | null
  onQuickSelect: (days: number) => void
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
  onDateRangeChange: () => void
  onRefresh: () => void
  onDownloadCSV: () => void
  onDownloadExcel: () => void
}

const CampaignStatsHeader: React.FC<CampaignStatsHeaderProps> = ({
  selectedDays,
  startDate,
  endDate,
  loading,
  statsData,
  onQuickSelect,
  onStartDateChange,
  onEndDateChange,
  onDateRangeChange,
  onRefresh,
  onDownloadCSV,
  onDownloadExcel,
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-6 text-white mb-6">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold">📊 Kampanya İstatistikleri</h1>
          <p className="text-blue-100 mt-2">Kampanya başvuru süreleri ve durum geçiş analizleri</p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          {/* Quick Select Buttons */}
          <div className="flex items-center space-x-2">
            <button
              className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                selectedDays === 1
                  ? "bg-white/20 text-white"
                  : "bg-white/10 text-white/80 hover:bg-white/15"
              }`}
              onClick={() => onQuickSelect(1)}
            >
              Son 1 Gün
            </button>
            <button
              className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                selectedDays === 7
                  ? "bg-white/20 text-white"
                  : "bg-white/10 text-white/80 hover:bg-white/15"
              }`}
              onClick={() => onQuickSelect(7)}
            >
              Son 7 Gün
            </button>
            <button
              className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                selectedDays === 30
                  ? "bg-white/20 text-white"
                  : "bg-white/10 text-white/80 hover:bg-white/15"
              }`}
              onClick={() => onQuickSelect(30)}
            >
              Son 30 Gün
            </button>
            <button
              className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                selectedDays === 90
                  ? "bg-white/20 text-white"
                  : "bg-white/10 text-white/80 hover:bg-white/15"
              }`}
              onClick={() => onQuickSelect(90)}
            >
              Son 90 Gün
            </button>
          </div>

          {/* Date Range Pickers */}
          <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-3 py-2">
            <span className="text-sm text-white">📅</span>

            <input
              type="date"
              className="bg-transparent border-none outline-none text-sm flex-1 min-w-[120px] appearance-none"
              style={{
                color: "white",
                WebkitTextFillColor: "white",
              }}
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              max={endDate}
              title="Başlangıç tarihi"
            />

            <span className="text-white text-sm">–</span>

            <input
              type="date"
              className="bg-transparent border-none outline-none text-sm flex-1 min-w-[120px] appearance-none"
              style={{
                color: "white",
                WebkitTextFillColor: "white",
              }}
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              min={startDate}
              max={new Date().toISOString().split("T")[0]}
              title="Bitiş tarihi"
            />

            <button
              className="bg-white/20 hover:bg-white/30 rounded px-2 py-1 text-white text-sm transition-colors cursor-pointer"
              onClick={onDateRangeChange}
              disabled={loading}
              title="Tarih aralığını uygula"
            >
              Uygula
            </button>
          </div>

          {/* Refresh Button */}
          <button
            className="bg-white/10 hover:bg-white/20 rounded-lg p-2 transition-colors"
            onClick={onRefresh}
            disabled={loading}
            title="Yenile"
          >
            <span className={`text-sm ${loading ? "animate-spin" : ""}`}>🔄</span>
          </button>

          {/* Export Buttons */}
          {statsData && statsData.data && statsData.data.length > 0 && (
            <div className="flex items-center space-x-2">
              <button
                className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg transition-colors flex items-center space-x-2 text-sm"
                onClick={onDownloadCSV}
                title="CSV İndir"
              >
                <span>📄</span>
                <span>CSV</span>
              </button>
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg transition-colors flex items-center space-x-2 text-sm"
                onClick={onDownloadExcel}
                title="Excel İndir"
              >
                <span>📊</span>
                <span>Excel</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CampaignStatsHeader
